// extracted by mini-css-extract-plugin
export var respuesta = "Pregunte-module--respuesta--AvjSk";
export var separatorBar = "Pregunte-module--separator-bar--6KasY";
export var titleContainer = "Pregunte-module--title-container--Ge6F3";